import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const pushChannel = defineChannel({
  id: 'push',
  icon: 'mobile',
  name: 'Push notification',
  shortName: 'push',
  noun: 'push notification',
  events: [
    'attempted',
    'sent',
    'delivered',
    'deferred',
    'failed',
    'bounced',
    'opened',
    'clicked',
    'drafted',
    'undeliverable',
  ],
  deliveryStates: ['attempted', 'sent', 'failed', 'bounced', 'suppressed', 'undeliverable', 'holdout', 'delivered'],
  deliveryActions: ['opened', 'converted'],
} as const satisfies ChannelDefinition);
